import { createSlice } from '@reduxjs/toolkit'
import { strapiFetch, StrapiApiError } from '../../api/strapi'

const slice = createSlice({
    name: 'home',
    initialState: {
        data: null,
        loading: false,
        loaded: false,
        error: null,
    },
    reducers: {
        setLoading: (state, action) => { state.loading = action.payload },
        setLoaded: (state, action) => { state.loaded = action.payload },
        setData: (state, action) => { state.data = action.payload },
        setError: (state, action) => { state.error = action.payload },
    },
})

export default slice.reducer

const { setLoading, setLoaded, setData, setError } = slice.actions

export const loadHomeData = (locale) => async dispatch => {
    dispatch(setLoading(true))
    dispatch(setError(null))
    dispatch(setData(null))
    try {
        // Nested media + shared.button need explicit populate paths;
        // `populate=*` only reaches one level deep.
        const json = await strapiFetch('/api/home-page', {
            locale,
            params: {
                'populate[seo]': 'true',
                'populate[heroSlides][populate][image]': 'true',
                'populate[designSection][populate][image]': 'true',
                'populate[designSection][populate][button]': 'true',
                'populate[projectsSection][populate][button]': 'true',
                'populate[projectsSection][populate][slides][populate][image]': 'true',
            },
        })
        dispatch(setData(json.data))
        dispatch(setLoaded(true))
    } catch (e) {
        dispatch(setError(e instanceof StrapiApiError ? e.message : 'Failed to load home page'))
    } finally {
        dispatch(setLoading(false))
    }
}
